(function iefe(w, d) {
    const comments = d.querySelector('.tx_nsnewscomments');
    const msg = d.querySelector('.messages.approve-error');

    if (!comments) {
        return;
    }

    const config = { attributes: true, childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    const callback = (mutationList) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'attributes') {
                msg.focus();
            }
        }
    };
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(msg, config);
    function buttoninit() {
        let button = d.querySelector('.ns-btn-send');
        button.addEventListener('click', () => {
            setTimeout(() => {
                button.setAttribute('disabled', '');
            }, 100);

            setTimeout(() => {
                button = d.querySelector('.ns-btn.ns-btn-send');
                if (button) {
                    button.removeAttribute('disabled');
                }
                if (msg.checkVisibility()) {
                    msg.focus();
                }
            }, 1200);
        });
    }

    const callback2 = (mutationList) => {
        for (const mutation of mutationList) {
            if (mutation) {
                /* buttoninit(); */
            }
        }
    };

    const observer2 = new MutationObserver(callback2);

    observer2.observe(comments, config);

    buttoninit();
}(window, document));
